import React, {forwardRef, ReactNode} from 'react'
import {FormattedMessage} from "react-intl";
import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import Text from './Text'

type I18NTextProps = {
    intent?: string,

    values?: object,

    children?: ReactNode
} & UnnormalizedStyleProps

const I18NText = forwardRef<HTMLParagraphElement, I18NTextProps>((
    {
        intent,

        values,
        children,
        ...props
    }, ref
) => {
    return <Text
        ref={ref}
        intent={intent}
        {...props}
    >
        <FormattedMessage
            id={children as string}
            values={values as Record<string, any>}
        />
    </Text>
})

export default I18NText
